// components/received/ReceivedEndowmentHeader.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { formatDateTime } from '../../utils/dateUtils';
import '../../styles/components/receivedHeader.css';

const ReceivedEndowmentHeader = ({ inheritance }) => {
  // Function to remove .txt extension
  const removeTxtExtension = (name) => {
    if (name && name.endsWith('.txt')) {
      return name.slice(0, -4);
    }
    return name;
  };

  return (
    <div className="re-inheritance-header">
      <h3 className="re-title">Selected Endowment: {inheritance ? removeTxtExtension(inheritance.filename)  : 'None'}</h3>


      <div className="re-inheritance-info">
        <div className="re-creator-info">
          <p><span className="re-label">Created by:</span> <span>{inheritance?.creator_email?.split('@')[0] || 'Unknown'}</span></p>
          <p><span className="re-label">Creator Email:</span> <span>{inheritance?.creator_email || 'Unknown'}</span></p>
          <p><span className="re-label">Release Date:</span> <span>{inheritance?.release_date ? new Date(inheritance.release_date).toLocaleDateString('en-US', { timeZone: 'UTC' }) : 'Unknown'}</span></p>
          <p><span className="re-label">Expiration Date:</span> <span>{inheritance?.expiration_date ? new Date(inheritance.expiration_date).toLocaleDateString() : 'Unknown'}</span></p>
        </div>

        <div className="re-inheritance-status">
          <span className={`re-status-badge ${inheritance?.is_accepted ? 'accepted' :
              inheritance?.is_declined ? 'declined' : 'pending'
            }`}>
            <i className={`fas ${inheritance?.is_accepted ? 'fa-check-circle' :
                inheritance?.is_declined ? 'fa-times-circle' : 'fa-clock'
              }`}></i>
            {inheritance?.is_accepted ? 'Acknowledged' :
              inheritance?.is_declined ? 'Declined' : 'Pending'}
          </span>
        </div>
      </div>
    </div>

  );
};

ReceivedEndowmentHeader.propTypes = {
  inheritance: PropTypes.shape({
    id: PropTypes.string,
    filename: PropTypes.string,
    creator_email: PropTypes.string,
    release_date: PropTypes.string,
    expiration_date: PropTypes.string,
    is_accepted: PropTypes.bool,
    is_declined: PropTypes.bool
  })
};

export default ReceivedEndowmentHeader;